module.exports = __webpack_public_path__ + "static/media/resource-success-notification-icon.2dc6161b.svg";